export const IDB_STORE_NAME = 'actassa-database';
